import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-form-help-text',
  templateUrl: './form-help-text.component.html',
  styleUrls: ['./form-help-text.component.scss']
})
export class FormHelpTextComponent implements OnInit {
  @Input() helpText: string;

  constructor() { }

  ngOnInit(): void {
  }

}
